import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MailFormGroup } from '@common/components/export-to-pst/export-to-pst.model';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MbsLabelSize } from 'mbs-ui-kit';

@UntilDestroy()
@Component({
  selector: 'app-mail-filter',
  templateUrl: './mail-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MailFilterComponent {
  @Output() isMailFilterChange = new EventEmitter<boolean>();

  @Input({ required: true }) currentDay!: Date;
  @Input({ required: true }) formGroup!: FormGroup<MailFormGroup>;

  public isMailFilter = true;
  public readonly MbsLabelSize = MbsLabelSize;

  get mailCheckedCtrl(): FormControl<boolean> {
    return this.formGroup.get('checked') as FormControl<boolean>;
  }

  get mailFilterCtrl(): FormGroup {
    return this.formGroup.get('filter') as FormGroup;
  }

  get mailFilterFromCtrl(): FormControl<Date> {
    return this.mailFilterCtrl.get('from') as FormControl<Date>;
  }

  get mailFilterToCtrl(): FormControl<Date> {
    return this.mailFilterCtrl.get('to') as FormControl<Date>;
  }

  mailFilterChange(state: boolean): void {
    this.isMailFilterChange.emit(state);
    state ? this.mailFilterCtrl.enable() : this.mailFilterCtrl.disable();
  }
}
